{
  "duration-form": {
    "text": {
      "hour": "Giờ",
      "minute": "Phút"
    }
  }
}
